<div class="dialog-header">
  <h3 matDialogTitle>{{confirmMessage}}</h3>
  <button class="close-button" mat-icon-button tabindex="-1" (click)="close(false)">
    <i class="Bosch-Ic Bosch-Ic-abort" aria-hidden="true"></i>
  </button>
</div>
<mat-dialog-content>  
    <control-list [config]="buttonConfig"></control-list>
</mat-dialog-content>